import React, {
  useEffect,
  useRef,
  forwardRef,
  useState,
  useCallback,
} from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import logAppEvent from '../../Api/appEventsLogging'
import { BsArrowLeft } from 'react-icons/bs'
import './dropdown.css'
import { useSelector } from 'react-redux'

const AskMeetingDropdown = forwardRef((props, ref) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [dropdownData, setDropdownData] = useState([])
  const [showMeetingsData, setShowMeetingsData] = useState(false)
  const [search, setSearch] = useState('')
  const navigate = useNavigate()
  const [showFilterDropdown, setShowFilterDropdown] = useState(false)
  const dropdownRef = useRef(null)
  const user = useSelector((state) => state?.user?.data)
  useEffect(() => {
    document.addEventListener('click', (event) => {
      if (ref?.current?.contains(event?.target)) {
        setShowFilterDropdown(true)
        if (props?.resetFilters) {
          props.resetFilters('')
        }
      } else {
        if (dropdownRef?.current?.contains(event?.target)) {
          setShowFilterDropdown(true)
        } else {
          setShowFilterDropdown(false)
          setShowMeetingsData(false)
          setSearch('')
        }
      }
    })
    return () => {
      document.removeEventListener('click', () => {})
    }
  }, [ref, props, setSearch])

  useEffect(() => {
    setShowMeetingsData(props.isMeeting)
  }, [props.isMeeting])

  useEffect(() => {
    if (props?.data?.length > 0) {
      if (search.trim() === '') {
        setDropdownData([
          ...props.data.filter(
            (item) => props.activeFilters.indexOf(item.value) !== -1
          ),
          ...props.data.filter(
            (item) => props.activeFilters.indexOf(item.value) === -1
          ),
        ])
      } else {
        setDropdownData([
          ...props.data.filter(
            (item) =>
              item.label.toUpperCase().includes(search.trim().toUpperCase()) &&
              props.activeFilters.indexOf(item.value) !== -1
          ),
          ...props.data.filter(
            (item) =>
              item.label.toUpperCase().includes(search.trim().toUpperCase()) &&
              props.activeFilters.indexOf(item.value) === -1
          ),
        ])
      }
    } else {
      setDropdownData([])
    }
  }, [setDropdownData, search, props.data, props.activeFilters])

  const changeHandler = useCallback(
    (value) => {
      if (props.isMultiple) {
        if (value === '') {
          if (props.filterName) {
            if (props.filterName === 'tag') {
              const task = searchParams.get('task')
              const card = searchParams.get('card')
              navigate(`/tasks/?tag=&task=${task}&card=${card}`)
            }
          } else {
            props.setActiveFilters([''])
          }
        } else {
          const activeFiltersTemp = [...props.activeFilters]
          const valueIndex = activeFiltersTemp.indexOf(value)
          const noFilterIndex = activeFiltersTemp.indexOf('')
          if (noFilterIndex !== -1) {
            activeFiltersTemp.splice(noFilterIndex, 1)
          }
          if (valueIndex === -1) {
            activeFiltersTemp.push(value)
            logAppEvent('ask_specific_meeting_dropdown_select', {
              user_id: user?.id,
            })
          } else {
            activeFiltersTemp.splice(valueIndex, 1)
            logAppEvent('ask_specific_meeting_dropdown_deselect', {
              user_id: user?.id,
            })
          }
          if (props.filterName) {
            if (props.filterName === 'tag') {
              navigate(
                `/tasks/?tag=${activeFiltersTemp.join(',')}&task=&card=`
              )
            }
          } else {
            props.setActiveFilters([...activeFiltersTemp])
          }
        }
      } else {
        props.setActiveFilters(value)
        setShowFilterDropdown(false)
        setSearch('')
      }
    },
    [props, searchParams, navigate, setShowFilterDropdown, setSearch]
  )

  const handleMyOwnCallClick = () => {
    logAppEvent('ask_my_own_calls_dropdown_select', {
      user_id: user?.id,
    })
    props.setSearchWithin('my own calls')
    props.setActiveFilters([''])
  }

  const handleChooseMeetingClick = () => {
    logAppEvent('ask_choose_meetings_dropdown_select', {
      user_id: user?.id,
    })

    props.setSearchWithin('choose meeting(s)')
    setShowMeetingsData(true)
  }
  return (
    <>
      {showFilterDropdown && props?.data?.length > 0 && (
        <div
          className={
            props.searchWithin === 'choose meeting(s)' && showMeetingsData
              ? 'dropdown expand'
              : 'dropdown'
          }
          ref={dropdownRef}
        >
          <div style={{ ...(!showMeetingsData && { display: 'none' }) }}>
            <button className='back-button'>
              <BsArrowLeft
                size={15}
                onClick={() => setShowMeetingsData(false)}
              />
              {props.isSearchable && (
                <div className='search'>
                  <input
                    value={search}
                    placeholder='Choose meetings...'
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              )}
            </button>
            {dropdownData?.map((item) => (
              <div
                onClick={() => {
                  changeHandler(item.value)
                }}
                key={item.value}
                className={
                  props.isMultiple
                    ? props.activeFilters.indexOf(item.value) !== -1
                      ? 'label active'
                      : 'label'
                    : props.activeFilters === item.value
                      ? 'label active'
                      : 'label'
                }
              >
                {props.isMultiple && (
                  <div>
                    {props.activeFilters.indexOf(item.value) !== -1 ? '✔' : ''}
                  </div>
                )}
                <span>{item.label}</span>
              </div>
            ))}
          </div>
          <div style={{ ...(showMeetingsData && { display: 'none' }) }}>
            <h4>Searching within</h4>

            <div
              className={
                props.searchWithin === 'my own calls' ? 'label active' : 'label'
              }
              onClick={handleMyOwnCallClick}
            >
              <span>my own calls</span>
            </div>
            <div className='label disable'>
              <span>my org&apos;s calls (coming soon)</span>
            </div>

            <div
              className={
                props.searchWithin === 'choose meeting(s)'
                  ? 'label active'
                  : 'label'
              }
              onClick={handleChooseMeetingClick}
            >
              <span>choose meeting(s)</span>
            </div>
          </div>
        </div>
      )}
    </>
  )
})

AskMeetingDropdown.displayName = 'AskMeetingDropdown'
export default AskMeetingDropdown
